export default "__VITE_ASSET__BZbqLFqr__"